import React from 'react';
import { Placeholder } from '@thd-olt-component-react/core-ui';

// Determines the # of pixels below the "fold" before starting hydration
export const SCROLL_BUFFER_DESKTOP = 1000;
export const SCROLL_BUFFER_MOBILE = 2000;

// Determines a delay for the hydrator in milliseconds
export const HOMEPAGE_DELAY_STANDARD = 250;

// Averages were taken of all card components to determine height for mobile/desktop
export const HOMEPAGE_PLACEHOLDER_DESKTOP = <Placeholder type="rect" height="400px" width="100%" />;
export const HOMEPAGE_PLACEHOLDER_MOBILE = <Placeholder type="rect" height="360px" width="100%" />;

// Section needs it's own placeholders to address its own CWV's
export const SECTION_PLACEHOLDER_DESKTOP = <Placeholder type="rect" height="390px" width="100%" />;
export const SECTION_PLACEHOLDER_MOBILE = <Placeholder type="rect" height="225px" width="100%" />;
